<template>
  <div v-if="actions.length" class="col-4 pull-right">
    <b-row>
      <b-col sm="10">
        <b-form-select :options="options" size="sm" v-model="value"/>
      </b-col>
      <b-col>
        <b-button variant="primary" size="sm" block @click="submit">
          <i class="nav-icon icon-control-play"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            actions: {
                type: Array,
                default: [],
            },
            endpoint: {
                type: String,
                default: null,
                required: true,
            }
        },

        data() {
            return {
                value: null,
            }
        },

        computed: {
            options() {
                let options = this.actions.map((action) => {
                    return {
                        value: action.name,
                        text: action.label,
                    }
                });

                options.unshift({
                    value: null,
                    text: '-- Selecteer een actie',
                });

                return options;
            }
        },

        methods: {
            async submit() {

                if (this.value === null) {
                    return;
                }

                const namespace = this.endpoint;

                const filtersJson = localStorage.getItem(`${namespace}-filters`);
                const filters = filtersJson ? JSON.parse(filtersJson) : [];

                let params = {
                    action: this.value,
                };

                filters.forEach(filter => {
                    params[filter.name] = filter.value;
                });

                const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

                switch (this.actions.find(x => x.name === this.value).type) {
                    case 'download':
                        this.startDownload(`${this.endpoint}?${queryString}`);
                        return;
                    case 'response':
                        this.showResponse(`${this.endpoint}?${queryString}`);
                        return;
                }
            },

            async startDownload(address) {
                let response = await axios({
                    url: process.env.VUE_APP_API_URL + '/cms/' + address,
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Accept': 'application/json',
                    },
                    responseType: 'arraybuffer',
                    method: 'GET'
                });

                let blob = new Blob([response.data], {type: response.data.type});
                let url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'unknown';
                if (contentDisposition) {
                    const regex = /filename="?(.*)"?/gmi;
                    const fileNameMatch = regex.exec(contentDisposition);
                    if (fileNameMatch.length === 2)
                        fileName = fileNameMatch[1];
                }
                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            },

            showResponse(address) {
                console.group('ResourceActions => fn.ShowResponse');
                console.log('To be implemented');
                console.groupEnd();
            }
        }
    }
</script>
